import Vue from "vue";
import validatePop from "@/plugins/validatePop.js";
const vm = new Vue();

export const checkStatusShop = () => {
    return new Promise((resolve, reject) => {
        vm.$http
            .get(vm.$API_URL  + "/shop/noti", {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            })
            .then(res => {
                let data = res.data.data;
                let checkError = validatePop(res);
                if (!checkError.status) {
                  reject(checkError.msg+ ' #NotiError');
                }
                resolve(data)
            })
    });
}